/* Component auto-generated by packages/icons/scripts/generateIconsComponents.js */
/* eslint-disable max-len */
import React from 'react';
const FlashOddsIcon = (props) => (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor" }, props),
    React.createElement("g", { "clip-path": "url(#clip0)" },
        React.createElement("path", { d: "M17.0268 9.4524L6.4788 20.316L9.7248 12.3372H7.3812L10.9428 3.6816H17.5248L12.972 9.4512H17.0292L17.0268 9.4524ZM12 0C5.3724 0 0 5.3724 0 12C0 18.6276 5.3724 24 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0Z" }))));
export default FlashOddsIcon;
